// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Section-module--cls1--3B6kM","cls2":"styles-Section-module--cls2--AXXpR styles-Section-module--cls1--3B6kM"};